import * as React from 'react';

interface H6Props {
}

const H6: React.FC<H6Props> = (props) => {
  return <h6 className="mt-4 mb-2">{props.children}</h6>
};

export {H6};